/* eslint-disable array-callback-return */
/* eslint-disable no-lone-blocks */
/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";

import {
  TimeStampIntoHours,
  isWeekend
  // renderShift
  // TimeStampIntoHours
} from "../../../constant/helper/helper";

const ShowDateList = ({ dayList }) => {
  return dayList.map((dateValue, dateIndex) => {
    const weekendOrNot = isWeekend(dateValue.Date);

    return (
      <Fragment key={dateIndex}>
        <td
          className={
            weekendOrNot
              ? "table-action text-center bg-danger-lighten"
              : "table-action text-center"
          }
        >
          <span>{TimeStampIntoHours(dateValue?.breakFastTime)}</span>
        </td>
        <td
          className={
            weekendOrNot
              ? "table-action text-center bg-danger-lighten"
              : "table-action text-center"
          }
        >
          <span>{TimeStampIntoHours(dateValue?.lunchTime)}</span>
        </td>
        <td
          className={
            weekendOrNot
              ? "table-action text-center bg-danger-lighten"
              : "table-action text-center"
          }
        >
          <span>{TimeStampIntoHours(dateValue?.dinnerTime)}</span>
        </td>
      </Fragment>
    );
  });
};

ShowDateList.propTypes = {
  dayList: PropTypes.array.isRequired
};

export default ShowDateList;
